/* eslint-disable arrow-body-style */
import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {StationsConfiguration} from "./stations-configuration";
import {TimeSeriesConfiguration} from "./time-series-configuration";
import {TimeSeries} from "../kiwis";
import {TimeRangeExtensionConfiguration} from "./time-range-extension-configuration";
import {KiwisQueryConfiguration, kiwisQueryTypePredicate} from "./kiwis-query-configuration";
import {TimeExtensionRuleConfiguration} from "./time-extension-rule-configuration";
import {DataAggregationType, GeneralisationConfiguration} from "./generalisation-configuration";
import {GeneralisationRuleConfiguration} from "./generalisation-rule-configuration";

@JsonObject()
export class StationDocumentsMapping {
    @JsonProperty()
    declare label: string;

    @JsonProperty()
    declare propertyName: string;
}

@JsonObject()
export class KiwisConfiguration {

    // KIWIS base url
    @JsonProperty()
    declare url: string;

    /**
     * Document service base URL
     */
    @JsonProperty()
    declare stationDocumentsBaseUrl: string;

    /**
     * Document service relative URL
     */
    @JsonProperty()
    declare stationDocumentsServiceUrl: string;

    /**
     * Configuration of the station documents
     */
    @JsonProperty()
    declare stationDocumentsConfig: StationDocumentsMapping[];

    /**
     * Configuration of the station images
     */
    @JsonProperty()
    declare stationImagesConfig: StationDocumentsMapping[];

    /**
     * Queries with parameters to get stations and time series
     */
    @JsonProperty({ type: kiwisQueryTypePredicate })
    declare queries: KiwisQueryConfiguration[];

    /**
     * Configuration of measure stations
     */
    @JsonProperty()
    declare stations: StationsConfiguration;

    /**
     * Configuration of time series
     */
    @JsonProperty()
    declare timeSeries: TimeSeriesConfiguration;

    constructor(props?: any) {
        if (props) {
            Object.assign(this, props);
        }
    }

    getTimeRangeExtensionConfig(timeSeries: TimeSeries): TimeRangeExtensionConfiguration {
        return this.timeSeries.timeRangeExtensions.filter((g) => {
            return g.stationParameterNames.includes(timeSeries.stationParameterName);
        })[0];
    }

    getTimeRangeExtensionRule(timeSeries: TimeSeries, period: string): TimeExtensionRuleConfiguration | null {
        const extensionConfig = this.getTimeRangeExtensionConfig(timeSeries);
        if (!extensionConfig) {
            return null;
        }
        const extensionRule = extensionConfig.rules.filter((rule: TimeExtensionRuleConfiguration) => {
            return rule.period === (period);
        })[0];
        if (!extensionRule) {
            throw new Error(`No extension rule defined for ${timeSeries.stationParameterName} ${period}`);
        }
        return extensionRule;
    }


    getGeneralisationConfig(timeSeries: TimeSeries): GeneralisationConfiguration {
        return this.timeSeries.generalisation.filter((g) => {
            return g.stationParameterNames.includes(timeSeries.stationParameterName);
        })[0];
    }

    getGeneralisationRule(timeSeries: TimeSeries): GeneralisationRuleConfiguration | null {
        const generalisationConfig = this.getGeneralisationConfig(timeSeries);
        if (!generalisationConfig || generalisationConfig.aggregationType === DataAggregationType.None) {
            return null;
        }

        const period = timeSeries.periodISO || timeSeries.DEFAULT_PERIOD;
        const generalisationRule = generalisationConfig.rules.filter((rule) => {
            return rule.period === (period);
        })[0];
        if (!generalisationRule) {
            throw new Error(`No generalization rule defined for ${timeSeries.stationParameterName} ${period}`);
        }
        return generalisationRule;
    }
}
